module.exports = __webpack_public_path__ + "img/16.844b951e.gif";